import { Injectable } from "@angular/core";
import { Subject } from "rxjs";


@Injectable({ providedIn: 'root' })
export class LogMessagesService {
  
  toSelectLogMessagesOnMap = new Subject<string>();
    
  
  selectMessageOnMap(id: string)
  {
    this.toSelectLogMessagesOnMap.next(id);
  }
   
}

